document.addEventListener('DOMContentLoaded', function () {
  
  var shop_grid = document.querySelector('.wb-shop-grid');
  if (!shop_grid) {
    return;
  }
  if($(shop_grid).hasClass('wb-shop-grid--ai')){
    return;
  }

  var layoutMode = 'fitRows';

  if (GeoRedirect.isBot()) {
    layoutMode = 'none';

    Isotope.Item.prototype._create = function() {
      this.id = this.layout.itemGUID++;
      this._transn = {
        ingProperties: {},
        clean: {},
        onEnd: {}
      };
      this.sortData = {};
    };

    Isotope.Item.prototype.layoutPosition = function() {
      this.emitEvent('layout', [this]);
    };

    Isotope.prototype.arrange = function(opts) {
      this.option(opts);
      this._getIsInstant();
      this.filteredItems = this._filter(this.items);
      this._isLayoutInited = true;
    };

    Isotope.LayoutMode.create('none');
  } else {
    var FitRows = Isotope.LayoutMode.create('fitRows');

    FitRows.prototype._resetLayout = function() {
      this.x = 0;
      this.y = 0;
      this.maxY = 0;
      this.row = 0;
      this.rows = [];
      this._getMeasurement( 'gutter', 'outerWidth' );
      if (typeof window.equalHeightInstance !== 'undefined') {
        window.equalHeightInstance.resetGrid(this.element);
      }
      if (this.options.equalHeight) {
        for (var i=0; i < this.isotope.items.length; i++) {
          this.isotope.items[i].css({
            height: 'auto'
          });
        }
//         if (typeof window.equalHeightInstance !== 'undefined') {
//           window.equalHeightInstance.updateGrid(this.element, this.isotope.filteredItems);
//         }
      }
    };

    FitRows.prototype._getItemLayoutPosition = function( item ) {
      item.getSize();

      var itemWidth = item.size.outerWidth + this.gutter;
      var containerWidth = this.isotope.size.innerWidth + this.gutter;
      if ( this.x !== 0 && itemWidth + this.x > containerWidth ) {
        this.x = 0;
        this.y = this.maxY;
      }

      if (this.x == 0 && this.y != 0) {
        this.row++;
      }

      var position = {
        x: this.x,
        y: this.y,
      };

      this.maxY = Math.max( this.maxY, this.y + item.size.outerHeight );
      this.x += itemWidth;

      if (typeof this.rows[this.row] == 'undefined') {
        this.rows[this.row] = [];
        this.rows[this.row].start = this.y;
        this.rows[this.row].end = this.maxY;
      } else {
        this.rows[this.row].end = Math.max(this.rows[this.row].end, this.maxY);
      }

      item.row = this.row;

      return position;
    };

    FitRows.prototype._equalHeight = function() {
      for (var i=0; i < this.isotope.filteredItems.length; i++) {
        var row = this.isotope.filteredItems[i].row,
            data = this.rows[row];

        if (data) {
          var height = Math.ceil(data.end - data.start);

          height -= this.isotope.filteredItems[i].size.borderTopWidth + this.isotope.filteredItems[i].size.borderBottomWidth;
          height -= this.isotope.filteredItems[i].size.marginTop + this.isotope.filteredItems[i].size.marginBottom;
          height -= this.gutter.height || 0;

          if (this.isotope.filteredItems[i].size.isBorderBox == false) {
            height -= this.isotope.filteredItems[i].size.paddingTop + this.isotope.filteredItems[i].size.paddingBottom;
          }

          this.isotope.filteredItems[i].size.height = height;

          this.isotope.filteredItems[i].css({
            height: height.toString() + 'px',
          });
        }
      }
    }

    FitRows.prototype._getContainerSize = function() {
      if (this.options.equalHeight) {
        this._equalHeight();
      }
      return { height: this.maxY };
    };

    Isotope.prototype._layout = function() {
      var t = this._getIsInstant();
      this._resetLayout();
      this._manageStamps();
      this.layoutItems(this.filteredItems, t);
      if (this.options[this.options.layoutMode] && this.options[this.options.layoutMode].equalHeight && typeof window.equalHeightInstance !== 'undefined') {
//         for (var i=0; i < this.filteredItems.length; i++) {
//           this.filteredItems[i].css({
//             height: 'auto'
//           });
//         }
        window.equalHeightInstance.updateGrid(this.element, this.filteredItems);
//         this._resetLayout();
//         this.layoutItems(this.filteredItems, t);
      }
      if (this.options.custom && this.options.custom.afterLayout) {
        this.options.custom.afterLayout(this);
      }
      this._isLayoutInited = !0;
    };
    
    Isotope.prototype.arrange = function(opts) {
      this.option( opts );
      this._getIsInstant();

      var filtered = this._filter( this.items );
      this.filteredItems = filtered.matches;

      this._bindArrangeComplete();

      if ( this._isInstant ) {
        this._noTransition( this._hideReveal, [ filtered ] );
      } else {
        this._hideReveal( filtered );
      }

      this._sort();
      if (this.options.custom && this.options.custom.beforeArrangeLayout) {
        this.options.custom.beforeArrangeLayout(this);
      }
      this._layout();
    };
    
    Isotope.prototype._init = Isotope.prototype.arrange;
  }

  window.$gbl_grid = $(shop_grid).isotope({
    percentPosition: true,
    itemSelector: '.wb-shop-grid__item',
    layoutMode: layoutMode,
    fitRows: {
      equalHeight: !(window.location.pathname.indexOf('shop-sportswear') !== -1 && isMobile()) && !GeoRedirect.isBot(),
      columnWidth: '.wb-shop-grid__item',
      gutter: 0
    },
    getSortData: {
      price: function(item) {
        return parseInt(item.dataset.price || 0);
      },
      date: function(item) {
        return parseInt(item.dataset.date || 0);
      },
      order: function(item) {
        return parseInt(item.dataset.order || 0);
      }
    },
    originLeft: document.documentElement.dir === 'ltr'
  });
  if (typeof window.gridCollectionContentUpdate === 'function') {
    window.$gbl_grid.on('arrangeComplete', window.gridCollectionContentUpdate);
  }
  
  setTimeout(function () {
     window.$gbl_grid.isotope();
  }, 5000);
  
}, false);
